// tslint:disable
import { callStatic, ReviewsListResponse } from 'services/api-service'

/**
 * List of related reviews
 *
 * @method
 * @name ApiService#relatedReviewsList
 * @param {string} sku - 
 * @param {integer} offset - 
 * @param {integer} limit - 
 * @param {string} sort - Default value and which options are available depends on site settings:
 * mostRecent
 * mostHelpful (formerly bestR)
 * expert (expert reviews first)
 * staff (staff reviews first)
 * topContributors (reviews first)
 * highestRated
 * lowestRated
 * mostRelevant
 * photosVideos
 * oldest

 */
function relatedReviewsList(parameters: {
  sku: string
  offset: number
  limit: number
  sort:
    | 'mostRecent'
    | 'mostHelpful'
    | 'expert'
    | 'staff'
    | 'topContributors'
    | 'highestRated'
    | 'lowestRated'
    | 'mostRelevant'
    | 'photosVideos'
    | 'oldest'
}): Promise<ReviewsListResponse> {
  return callStatic<ReviewsListResponse>(
    '/sitedata/{siteKey}/{sku}/r/relatedReview/{locale}/{offset}/{limit}/{sort}',
    parameters,
    ['sku', 'offset', 'limit', 'sort']
  )
}

export default { relatedReviewsList }
